import React, { PureComponent } from 'react';
import TextInput from '../../../../../Shared/TextInput';
import apolloClient from '../../../../../../apollo.client';
import { getInstagramUrl } from '../../../../../../apollo.queries';

class Instagram extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { url, initialMedia } = this.state;

    const { profile, requester } = this.props;

    return (
      <section className="instagram-uploader">
        {
          initialMedia
            ? <RenderMedia
                profile={profile}
                requester={requester}
                initialMedia={initialMedia}
                onSelect={itemSelected => this.setState({ itemsSelected: [ ...itemsSelected, itemSelected ] })}
                onRemove={itemSelected => this.setState({ itemsSelected: itemsSelected.filter(item => item.id !== itemSelected.id) })}
                itemsSelected={itemsSelected}
                />
            : <div className="to-center-within">
                <TextInput
                  label=""
                  value={url}
                  onChange={val => this.setState({ url: val })}
                  placeholder="Instagram Url"
                />
                <button onClick={async () => {
                  const getInstagramUrlResponse = (
                    (await apolloClient.query({
                      query: getInstagramUrl,
                      variables: { url: url }
                    })) || {}
                  ).data.getInstagramUrl;
                }}>Download</button>
              </div>
        }
      </section>
    );
  }
};

export default Instagram;
